import { createContext, useState } from 'react'
import { ExperienceOptionsProps } from 'src/components/communitySurvey/createCommunitySurvey/steps/communityCreationExperience/communityCreationExperience.types'
import { SecondPostSurvey } from 'src/components/communitySurvey/secondPostSurvey'
import {
  PROGRESS_BAR_VALUE_SECOND_POST_EXPERIENCE_STEP,
  Step
} from 'src/components/communitySurvey/secondPostSurvey/secondPostSurvey.constants'
import { useUser } from 'src/hook/useUser'
import { THIRD_POST_SURVEY_BASE_KEY } from 'src/components/communitySurvey/communityModalSurvey.constants'
import {
  SecondPostSurveyContextProps,
  SecondPostSurveyProviderProps
} from './secondPostSurveyContext.types'

export const SecondPostSurveyContext = createContext<SecondPostSurveyContextProps | null>(null)

export const SecondPostSurveyProvider = ({ children }: SecondPostSurveyProviderProps) => {
  const { user } = useUser()
  const [secondPostExperienceValue, setSecondPostExperienceValue] = useState<
    ExperienceOptionsProps | undefined
  >()
  const [secondPostImprovementText, setSecondPostImprovementText] = useState('')
  const [secondPostMostLikedText, setSecondPostMostLikedText] = useState('')
  const [lastStep, setLastStep] = useState(Step.SecondPostExperience)
  const [lastProgressBarValue, setLastProgressBarValue] = useState(
    PROGRESS_BAR_VALUE_SECOND_POST_EXPERIENCE_STEP
  )
  const [isSecondPostSurveyOpen, setIsSecondPostSurveyOpen] = useState(false)

  const THIRD_POST_SURVEY_KEY = `${THIRD_POST_SURVEY_BASE_KEY}_${user.ucode}`

  const handleClose = () => {
    setIsSecondPostSurveyOpen(false)
  }

  return (
    <SecondPostSurveyContext.Provider
      value={{
        secondPostExperienceValue,
        setSecondPostExperienceValue,
        secondPostImprovementText,
        setSecondPostImprovementText,
        secondPostMostLikedText,
        setIsSecondPostSurveyOpen,
        setSecondPostMostLikedText,
        THIRD_POST_SURVEY_KEY,
        lastStep,
        setLastStep,
        lastProgressBarValue,
        setLastProgressBarValue,
        isSecondPostSurveyOpen
      }}
    >
      <SecondPostSurvey isOpen={isSecondPostSurveyOpen} onClose={handleClose} />
      {children}
    </SecondPostSurveyContext.Provider>
  )
}
